import React, {PureComponent} from 'react';
import {withRouter} from 'react-router-dom';
import {withTranslation} from 'react-i18next';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Nav = styled.nav`
  width: 250px;
`;

class SideMenu extends PureComponent {
  render() {
    const {currentAnchor, anchorChange, setInProp, history} = this.props;
    return (
      <div className="sidebar">
        <Nav>
          <ul className="nav">
            <li className="nav-item">
              <button className="menu-item side-menu-item"
                onClick={() => {
                  anchorChange('presentation');
                  setInProp();
                }}
              >
                    Cleanbill
              </button>
              {currentAnchor === 'presentation' && <div className="burger-selected-item" />}
              <button className="menu-item side-menu-item"
                onClick={() => {
                  anchorChange('advantages');
                  setInProp();
                }}>
                    Avantages
              </button>
              {currentAnchor === 'advantages' && <div className="burger-selected-item" />}
              <button className="menu-item side-menu-item"
                onClick={() => {
                  anchorChange('download');
                  setInProp();
                }}>
                    Téléchargement
              </button>
              {currentAnchor === 'download' && <div className="burger-selected-item" />}
              <button className="menu-item side-menu-item"
                onClick={() => {
                  anchorChange('newPartner');
                  setInProp();
                }}>
                    Devenez pro
              </button>
              {currentAnchor === 'newPartner' && <div className="burger-selected-item" />}
              <button className="menu-item side-menu-item"
                onClick={() => {
                  anchorChange('contact');
                  setInProp();
                }}>
                    Contact
              </button>
              {currentAnchor === 'contact' && <div className="burger-selected-item" />}
              <button onClick={() => history.push('/login')} className="menu-item side-menu-item">
                    Mon compte
              </button>
            </li>
              );
            })}
          </ul>
        </Nav>
      </div>
    );
  }
}

SideMenu.propTypes = {
  t: PropTypes.func.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

export default withRouter(withTranslation('common')(SideMenu));
